module.exports = __webpack_public_path__ + "static/media/nate-head.bab29119.png";